export function loadOneTrustConsent(env) {
  // Create and load the OneTrust script
  const oneTrustScript = document.createElement("script");
  oneTrustScript.type = "text/javascript";
  oneTrustScript.src = "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js";
  oneTrustScript.charset = "UTF-8";

  if (env === "prod") {
    oneTrustScript.setAttribute(
      "data-domain-script",
      "0195f1f7-e2bd-7c26-8961-833c96bf3f7b"
    );
  } else {
    oneTrustScript.setAttribute(
      "data-domain-script",
      "0195f1f7-e2bd-7c26-8961-833c96bf3f7b-test"
    );
  }

  document.head.appendChild(oneTrustScript);

  // Add the OptanonWrapper function
  window.OptanonWrapper = function () {};
}
